import React from 'react'
import styles from '../Components/AboutUs.module.css';
// import AboutUsBg from '/Images/AboutUsBg.jpg';
// import AboutUsQuality from '/Images/AboutUsQuality.jpeg'
// import AboutUsColorOptions from '/Images/AboutUsColorOptions.jpg'
// import AboutUsProffessional from '/Images/AboutUsProfessional.jpg'


export default function AboutUs() {
  return  (
    <div className={styles.container}>
    <section className={`${styles.section} ${styles.backgroundImageSection}`}>
      <div className={styles.innerContainer}>
        <div className={styles.grid}>
          <img
            src='/Images/AboutUsBg.jpg' // Use the imported image here
            width="650"
            height="433"
            alt="Beautifully Painted Room"
            className={styles.image}
          />
          <div className={styles.textContainer}>
            <div>
              <h1 className={styles.mainTitle}>Shital Paints</h1>
              <p className={styles.description}>
                We are a leading provider of high-quality wall paints, dedicated to transforming spaces with our
                exceptional products and professional painting services.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
      
      <section className={`${styles.section} ${styles.mutedBackground}`}>
        <div className={styles.innerContainer}>
          <div className={styles.textCenter}>
            <div>
              <h2 className={styles.secondaryTitle}>Our Expertise in Wall Paints</h2>
              <p className={styles.extendedDescription}>
                At Wall Paints Seller, we take pride in our extensive knowledge and expertise in the world of wall
                paints. Our high-quality products, diverse color selection, and professional painting services are
                designed to help you transform your spaces with ease.
              </p>
            </div>
          </div>
          <div className={styles.featuresGrid}>
            <div className={styles.feature}>
              <div className={styles.featureBadge}>High-Quality Paints</div>
              <p className={styles.featureDescription}>
                Our wall paints are formulated with the highest-quality ingredients, ensuring long-lasting durability,
                superior coverage, and a smooth, even finish.
              </p>
            </div>
            <img
              src='/Images/AboutUsQuality.jpeg' // Use the imported image here
              width="550"
              height="310"
              alt="Paint Cans"
              className={styles.featureImage}
            />
          </div>
          <div className={styles.featuresGrid}>
            <img
              src='/Images/AboutUsColorOptions.jpg' // Use the imported image here
              width="550"
              height="310"
              alt="Color Palette"
              className={styles.featureImage}
            />
            <div className={styles.feature}>
              <div className={styles.featureBadge}>Extensive Color Selection</div>
              <p className={styles.featureDescription}>
                Explore our vast selection of vibrant, on-trend colors to find the perfect hue for your space. Our team
                of experts is here to help you make the best color choices.
              </p>
            </div>
          </div>
          <div className={styles.featuresGrid}>
            <div className={styles.feature}>
              <div className={styles.featureBadge}>Professional Painting Services</div>
              <p className={styles.featureDescription}>
                Elevate your painting experience with our team of skilled professionals. From color consultation to
                expert application, we ensure a flawless finish every time.
              </p>
            </div>
            <img
              src='/Images/AboutUsProfessional.jpg' // Use the imported image here
              width="550"
              height="310"
              alt="Painting Service"
              className={styles.featureImage}
            />
          </div>
        </div>
      </section>
      
      {/* <section className={styles.section}>
        <div className={styles.innerContainer}>
          <div className={styles.textCenter}>
            <div>
              <h2 className={styles.secondaryTitle}>Meet Our Team</h2>
              <p className={styles.extendedDescription}>
                Our dedicated team of experts is committed to providing you with exceptional service and transforming
                your spaces with our high-quality wall paints.
              </p>
            </div>
          </div>
          <div className={styles.teamGrid}>
            <div className={styles.teamMember}>
              <img src={"https://documents.iplt20.com/ipl/IPLHeadshot2024/2.png"} alt="John Doe" className={styles.profilePic} />
              <h3 className={styles.teamName}>Virat Kholi</h3>
              <p className={styles.teamDesignation}>CEO</p>
              <p className={styles.teamDescription}>
                John has over 15 years of experience in the paint industry and is passionate about helping customers
                transform their spaces.
              </p>
            </div>
            <div className={styles.teamMember}>
              <img src={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQp5IMvU5mzUNUAVtUPVexkzgt3cDPUE6113Q&s"} alt="Sarah Adams" className={styles.profilePic} />
              <h3 className={styles.teamName}>Rohit Sharma</h3>
              <p className={styles.teamDesignation}>Color Specialist</p>
              <p className={styles.teamDescription}>
                Sarah is our resident color expert, helping customers find the perfect shades to suit their style and
                preferences.
              </p>
            </div>
            <div className={styles.teamMember}>
              <img src={"https://assets.vogue.in/photos/60ca4a4596d470590e0c7cc6/16:9/w_1280,c_limit/Shraddha%20Kapoor%20on%20self-care,%20skincare%20and%20the%20beauty%20product%20she'd%20love%20to%20create%20.jpg"} alt="Michael Roberts" className={styles.profilePic} />
              <h3 className={styles.teamName}>Shraddha Kapoor</h3>
              <p className={styles.teamDesignation}>Painting Supervisor</p>
              <p className={styles.teamDescription}>
                Michael leads our team of skilled painters, ensuring every project is completed to the highest
                standards.
              </p>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  )
}
